import { IconButton, Table } from '@dixa/lib-shared-habla';
import { Team } from 'lib-shared-legacy-types';
import { ampli } from 'lib-shared-tracking';

import { useCurrentUser } from 'utils/user';

import styles from '../teams.module.scss';

type TeamsTableRowOwnProps = {
  team: Team;
  showRemoveModal: (team: Team) => void;
  goToDetailsPage: (teamId: string) => void;
};

type StateProps = {};

type Props = TeamsTableRowOwnProps & StateProps;

export const TeamsTableRow = (props: Props): JSX.Element => {
  const {
    currentRole: { atLeastTeamlead },
  } = useCurrentUser();

  const handleDeleteClick = (): void => {
    ampli.settingsTeamRemoveTeamButtonClicked();

    const { team, showRemoveModal } = props;
    showRemoveModal(team);
  };

  const handleDetailsClick = (): void => {
    ampli.settingsTeamEditTeamButtonClicked();

    const { team, goToDetailsPage } = props;
    goToDetailsPage(team.id);
  };

  const { team } = props;

  return (
    <Table.Tr>
      <Table.Td>{team.name}</Table.Td>
      <Table.Td>{team.number_of_members}</Table.Td>
      <Table.Td className={styles.cellActions}>
        {atLeastTeamlead && (
          <>
            <IconButton
              variant="tertiary"
              icon="pen"
              onClick={handleDetailsClick}
            />
            <IconButton
              variant="tertiary"
              icon="trash"
              onClick={handleDeleteClick}
            />
          </>
        )}
      </Table.Td>
    </Table.Tr>
  );
};
